import bg from '../assets/bg.png';
import chef from '../assets/chef.png';
import cook from '../assets/cook1.jpg';
import G from '../assets/G.png';
import gallery01 from '../assets/gallery01.png';
import gallery02 from '../assets/gallery02.png';
import gallery03 from '../assets/gallery03.png';
import gallery04 from '../assets/gallery04.png';
import knife from '../assets/knife.png';
import logo from '../assets/logo.png';
import menu from '../assets/menu.png';
import overlaybg from '../assets/overlaybg.png';
import oval from '../assets/oval.png';
import misal1 from '../assets/misal1.jpg';
import misal2 from '../assets/misal2.jpg';
import Mostar from '../assets/Mostar1.jpg';
import welcome from '../assets/welcome.png';
import findus from '../assets/findus.png';
import laurels from '../assets/laurels.png';
import award01 from '../assets/award01.png';
import award02 from '../assets/award02.png';
import award03 from '../assets/award03.png';
import award05 from '../assets/award05.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import oriental from '../assets/oriental_logo.png';
import oriental_food_1 from '../assets/oriental_food_1.png';
import oriental_food_2 from '../assets/oriental_food_2.png';
import oriental_food_3 from '../assets/oriental_food_3.png';
import oriental_food_4 from '../assets/oriental_food_4.png';
import orientalFood_1 from '../assets/orientalFood_1.webp';
import turkish_kebab from '../assets/turkish_kebab.png';

export default {
  bg,
  chef,
  G,
  cook,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  knife,
  logo,
  menu,
  overlaybg,
  oval,
  misal2,
  misal1,
  Mostar,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  oriental,
  oriental_food_1,
  oriental_food_2,
  oriental_food_3,
  oriental_food_4,
  orientalFood_1,
  turkish_kebab
};
